module.exports = __webpack_public_path__ + "img/d200910-1.aac03028.jpg";